<h2 mat-dialog-title>
  <div class="dialog-title" fxLayout="column" fxLayoutAlign="space-between" fxFlex="100">
    <div fxLayout="row" fxLayoutAlign="space-between">
      <span>Are you sure you want to remove this item from your pickup?</span>
      <mat-icon fxFlex (click)="reference?.close()">close</mat-icon>
    </div>
  </div>
</h2>

<div mat-dialog-content>
  <p>Please note that if you remove this item and later decide to include it again, you will need to find it again in the item search.</p>
  <div class="actions" fxLayout="row" fxLayoutAlign="space-between">
    <button class="primary-btn" (click)="reference.close(false)">Cancel</button>
    <button class="primary-btn error-btn" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" (click)="reference.close(true)">
      Remove item
      <mat-icon svgIcon="delete"></mat-icon>
    </button>
  </div>
</div>
